import React from "react";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { Helmet } from "react-helmet";
import SectionHero2 from "components/SectionHero/SectionHero2";
import Heading from "components/Heading/Heading";

function PageHome() {
  return (
    <div className="relative overflow-hidden nc-PageHome">
      <Helmet>
        <title>The Moon Crown || Agent Molder</title>
      </Helmet>
      {/* GLASSMOPHIN */}
      <BgGlassmorphism />

      <div className="container relative my-12 sm:mb-24 sm:mt-24">
        {/* SECTION HERO */}
        <SectionHero2 />
      </div>

      <div className="container relative pt-12 mx-auto my-4 text-center border-gray-600 border-y-2">
        <p className="mb-12 text-xl lg:text-2xl">
        <a className="mr-2 md:ml-4" href="https://themooncrownpod.tumblr.com/tagged/transcripts">TRANSCRIPTS</a> |  
          <a className="mx-2 md:mr-4" href="https://anchor.fm/the-moon-crown">Anchor</a> | 
        <a className="mx-2 md:mx-4" href="https://podcasts.apple.com/us/podcast/the-moon-crown/id1630683271">Apple Podcasts</a> | 
        <a className="mx-2 md:mx-4" href="https://music.amazon.com/podcasts/f2f3744d-197e-4365-8325-e77d00123091/the-moon-crown">Amazon Music</a> | 
        <a className="mx-2 md:mx-4" href="https://pca.st/qnuuufrg">Pocket Casts</a> | 
        <a className="mx-2 md:mx-4" href="https://www.stitcher.com/show/711932">Stitcher</a> | 
        <a className="ml-2 md:ml-4" href="https://open.spotify.com/show/79GDG0T0dAJuY9SKRVbIeD">Spotify</a></p></div>
        <br/>
        <div className="container relative pb-24 mt-12 mb-4">
        <Heading
          desc={"Check out the most recent episode"}
          className="mb-8 text-neutral-900 dark:text-neutral-50"
        >
          Listen to Season One
        </Heading>

        <iframe title="Episode Two Preview - Bloopers" src="https://open.spotify.com/embed/show/79GDG0T0dAJuY9SKRVbIeD?utm_source=generator&theme=0" width="100%" height="152" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>

        <Heading
          desc={"Message One - Reality as You Perceive It "}
          className="mt-24 mb-8 text-neutral-900 dark:text-neutral-50"
        >
          Start from the beginning:
        </Heading>

        <iframe title="Episode One, Reality as you perceive it" src="https://open.spotify.com/embed/episode/3qelzV1JkH1TIB9b5eL5x5?utm_source=generator" width="100%" height="232" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>

      </div>


    </div>
  );
}

export default PageHome;
